/**
 * AuthHelper
 *
 * JWT Token helper functions
 */

import angular from 'angular';

const WINDOW = new WeakMap();

class AuthHelper {
  /* ----------------------------------- *\
   * Constructor
   \* ----------------------------------- */
  constructor($window) {
    WINDOW.set(this, $window);
  }

  urlBase64Decode(str) {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0: { break; }
      case 2: { output += '=='; break; }
      case 3: { output += '='; break; }
      default: {
        throw new Error('Illegal base64url string!');
      }
    }
    // polyfill https://github.com/davidchambers/Base64.js
    return WINDOW.get(this).decodeURIComponent(WINDOW.get(this).escape(WINDOW.get(this).atob(output)));
  }


  decodeToken(token) {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }
    const decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }
    return angular.fromJson(decoded);
  }

  getTokenExpirationDate(token) {
    const decoded = this.decodeToken(token);
    if (typeof decoded.exp === 'undefined') {
      return null;
    }
    const d = new Date(0); // The 0 here is the key, which sets the date to the epoch
    d.setUTCSeconds(decoded.exp);
    return d;
  }

  isTokenExpired(token, offsetSeconds) {
    if (!token) {
      return true;
    }
    let d;
    if (token === Object(token) && token.ttl) {
      d = new Date(0); // The 0 here is the key, which sets the date to the epoch
      d.setUTCSeconds(token.ttl);
    } else {
      d = this.getTokenExpirationDate(token);
    }
    offsetSeconds = offsetSeconds || 0;
    if (d === null) {
      return false;
    }
    // Token expired?
    const exp = d.getTime() > new Date().getTime() + (offsetSeconds * 1000);
    return !exp;
  }

  static factory($window) {
    return new AuthHelper($window);
  }
}

AuthHelper.factory.$inject = ['$window'];

const module = angular.module('auth.authHelper', [])
  .factory('authHelper', AuthHelper.factory);

export default module;



/** WEBPACK FOOTER **
 ** ./client/app/services/auth/authHelper.js
 **/